import zh_CN from './zh_CN'
import zh_TW from './zh_TW'
import en_US from './en_US'
import ko_KR from './ko_KR'
import vi_VN from './vi_VN'
import th_TH from './th_TH'
import tr_TR from './tr_TR'
import es_ES from './es_ES'
import pt_PT from './pt_PT'
import ja_JP from './ja_JP'
import ko_KP from './ko_KP'
export default { zh_CN,zh_TW,en_US,ko_KR,vi_VN,th_TH,tr_TR,es_ES,pt_PT,ja_JP,ko_KP, }